{
	"title": "Transactions en conciliation",
	"filterByLabel": "Filtrer par",
	"filterByPlaceholder": "Sélectionner un filtre",
	"filterOptions": {
		"paymentMethod": "Méthode de paiement",
		"paymentMethodCredit": "Crédit",
		"paymentMethodDebit": "Débit",
		"vendor": "Vendor",
		"status": "Statut"
	},
	"searchPlaceholder": "Rechercher...",
	"columns": {
		"transactionDate": "DATE DE LA TRANSACTION",
		"paymentMethod": "MÉTHODE DE PAIEMENT",
		"vendor": "VENDOR",
		"terminalNumber": "N° DU TERMINAL",
		"status": "STATUT",
		"value": "VALEUR",
		"receipt": "REÇU"
	},
	"statusPending": "EN ATTENTE",
	"statusProcessed": "TRAITÉE",
	"statusReconciled": "RÉCONCILIÉE",
	"statusCancelled": "ANNULÉE",
	"statusTooltipPaid": "Transaction déjà payée à l'acquéreur",
	"receiptTooltipView": "Voir le reçu",
	"receiptTooltipUnavailable": "Reçu indisponible",
	"of": "de",
	"backButton": "Retour"
}
